export default __webpack_public_path__ + "static/media/ico-printer.08086400.svg";